import Happening from 'components/Happening/Happening';
import { withHappeningProps } from 'viewModel/happening/withHappeningProps';

export default withHappeningProps(Happening);
